import { convertToTimezone, DateArgument } from "@epcnetwork/core-ui-kit";

import { userTimezone, appTimezone } from "constants/user.constants";

export const getDateWithTimezone = (date: DateArgument): Date => {
  return convertToTimezone(date, appTimezone, userTimezone);
};
